module.exports = __webpack_public_path__ + "assets/pickup-je-8cc562.svg";